// extracted by mini-css-extract-plugin
export var background = "PartnerStoriesSection-module__background___lfy+M";
export var backgroundImage = "PartnerStoriesSection-module__backgroundImage___FWn6N";
export var boxArt = "PartnerStoriesSection-module__boxArt___ED398";
export var card = "PartnerStoriesSection-module__card___HRomZ";
export var cards = "PartnerStoriesSection-module__cards___vCuhy";
export var content = "PartnerStoriesSection-module__content___XeY53";
export var game = "PartnerStoriesSection-module__game___USh9b";
export var quote = "PartnerStoriesSection-module__quote___hZShq";
export var section = "PartnerStoriesSection-module__section___ocWRY";
export var studio = "PartnerStoriesSection-module__studio___udpLH";
export var studioRow = "PartnerStoriesSection-module__studioRow___-TFQV";
export var studioText = "PartnerStoriesSection-module__studioText___3Wo--";